import React from 'react';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode
} from 'office-ui-fabric-react/lib/DetailsList';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';

import HttpService from '../../service/HttpService';
import Header from '../../component/Header';

export default class Types extends React.Component {
  http = new HttpService();
  loader = null;
  lo = require( 'lodash' );
  toPost = {};
  
  constructor( props ) {
    super( props );

    this.state = {
      viewOpen: false,
      showPanel: false,
      activeItem: {},
      items: []
    };
  }

  componentDidMount() {
    let loader = this.refs.header.loader().loading( 'Cargando tipos de pólizas...' );
    
    this.http
      .getTypes()
      .then( types => {
        this.setState({ items: types });

        loader.finish();
      })
      .catch( this.errorHandler );
  }

  errorHandler = ( error ) => {
    this.refs.header.dialog().show( error );
  }

  selectedItemChange = ( item ) => {
    this.setState({
      viewOpen: item
    });
  }

  newItemHandler = () => {
    this.setState({
      showPanel: true,
      activeItem: { }
    })
  }

  editItemHandler = () => {
    if( this.state.viewOpen !== false ) {
      this.setState({
        showPanel: true,
        activeItem: this.state.viewOpen
      })

      this.toPost = this.lo.cloneDeep( this.state.viewOpen );
    } else {
      this.setState({ activeItem: {} });

      this.errorHandler( 'Debe seleccionar un tipo de póliza para editar' );
    }
  }

  deleteItemHandler = () => {
    if( this.state.viewOpen !== false ) {

      let loader = this.refs.header.loader().loading( 'Guardando cambios...' );
      
      this.http
        .deleteTypes( this.state.viewOpen.id )
        .then( ( types ) => {
          this.toPost = null;

          this.setState({ items: types, activeItem: {}, viewOpen: false });

          loader.finish();
        })
    } else {
      this.errorHandler( 'Debe seleccionar un tipode póliza para eliminar' );
    }
  }

  saveItemHandler = () => {
    let loader = this.refs.header.loader().loading( 'Guardando cambios...' );

    this.http
      .saveTypes( this.toPost )
      .then( ( types ) => {
        this.toPost = null;

        this.setState({ items: types, activeItem: {}, viewOpen: false });
        
        loader.finish();
      })
      .catch( this.errorHandler );

    this.setState({ showPanel: false });
  }

  updateItem = ( item ) => {
    this.toPost[item.target.name] = item.target.value;
  }
  
  render() {
    const items = this.state.items;
    const columns = [
      {
        key: 'column2',
        name: 'Nombre',
        fieldName: 'name',
        minWidth: 210,
        maxWidth: 350,
        isRowHeader: true,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false,
        data: 'string',
        isPadded: true
      }
    ]

    const menuItems = [
      {
        text: 'Nuevo',
        iconProps: {
          iconName: 'Add'
        },
        onClick: this.newItemHandler
      },
      {
        text: 'Editar',
        iconProps: {
          iconName: 'Edit'
        },
        onClick: this.editItemHandler
      },
      {
        text: 'Eliminar',
        iconProps: {
          iconName: 'Delete'
        },
        onClick: this.deleteItemHandler
      }
    ];
    const menuFarItems = [
      {
        iconProps: {
          iconName: 'Info'
        }
      }
    ];
    const customItems = [];

    return (
      <Fabric>
        <Header title="Clientes" ref="header" visible={false}/>

        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg12" style={{ margin: 0, padding: 0 }}>
              <CommandBar
                  items={ menuItems }
                  overflowItems={ customItems }
                  farItems={ menuFarItems }
                />
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className={ "ms-Grid-col ms-sm12 " + ( this.state.viewOpen ? 'ms-lg9' : 'ms-lg12' ) } style={{ borderRight: '1px solid #ccc', paddingTop: 20 }}> 
              <DetailsList
                ref="listview"
                items={ items }
                columns={ columns }
                selectionMode={ SelectionMode.none }
                setKey="set"
                layoutMode={ DetailsListLayoutMode.justified } 
                onActiveItemChanged={ this.selectedItemChange } />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg3 ms-font-m" style={{ paddingTop: 20, display: this.state.viewOpen ? 'block' : 'none' }}>
              <h3 className="ms-font-xl">{ this.state.viewOpen.name }</h3>
              <hr />
            </div>
          </div>

          <Panel
            isOpen={this.state.showPanel}
            type={PanelType.smallFluid}
            onDismiss={ () => this.setState({ showPanel: false }) }
            headerText="Tipos de pólizas"
            onRenderFooter={ () => {
              return (
                <div className="ms-textAlignCenter">
                <PrimaryButton onClick={ this.saveItemHandler } style={{ marginRight: 10 }}>Guardar</PrimaryButton>
                <DefaultButton onClick={ () => this.setState({ showPanel: false }) } >Cancelar</DefaultButton>
              </div>

              )
            }}>
              <div className="ms-Grid">
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <TextField name="name" label="Nombre" value={ this.state.activeItem.name } onChange={ this.updateItem }/>
                  </div>
                </div>
              </div>
          </Panel>

        </div>
      </Fabric>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screen/settings/Types.jsx